/******/ (function() { // webpackBootstrap
/*!*************************!*\
  !*** ./js/datalayer.js ***!
  \*************************/
document.addEventListener('DOMContentLoaded', () => {
  // -------------------- UTILS --------------------
  function toNumber(v) {
    if (!v) return 0;
    const raw = String(v).trim().replace(',', '.');
    let n = parseFloat(raw);
    if (isNaN(n)) return 0;
    if (!raw.includes('.')) n = n / 100;
    return n;
  }
  function getContext() {
    if (document.body.classList.contains('template-index')) return 'homepage_card';
    if (document.body.classList.contains('template-collection')) return 'listing_card';
    if (document.body.classList.contains('template-search')) return 'search_card';
    if (document.body.classList.contains('template-product')) return 'pdp';
    return 'card';
  }

  // -------------------- COLLECT PRODUCTS --------------------
  function collectProductsFromDOM(context = document) {
    const cards = context.querySelectorAll('.j-productCard');
    const products = [];
    const ctx = getContext();
    let itemListName = 'Related Product PLP';
    let itemListId = 'related_product_plp';

    // if (ctx === 'pdp') {
    //   itemListName = 'Related Product PDP';
    //   itemListId = 'related_product_pdp';
    // } else if (ctx === 'homepage_card') {
    //   itemListName = 'Home Page';
    //   itemListId = 'home_page';
    // } else if (ctx === 'listing_card' || ctx === 'search_card') {
    //   itemListName = 'Related Product PLP';
    //   itemListId = 'related_product_plp';
    // }

    cards.forEach((card, i) => {
      products.push({
        item_brand: card.dataset.productBrand,
        item_id: card.dataset.productId,
        item_variant: card.dataset.productVariant,
        item_name: card.dataset.productName,
        index: i + 1,
        price: card.dataset.productPrice,
        discount: card.dataset.productDiscount,
        availability: card.dataset.productAvaibility,
        coupon: "",
        item_category: card.dataset.productCollection.trim(),
        item_category2: card.dataset.productCat2
      });
    });
    console.log(`[collectProductsFromDOM] ${products.length} prodotti trovati in contesto "${itemListName}"`);
    return products;
  }

  // Inizializza liste prodotto globali
  window.__PRODUCTS_LIST__ = collectProductsFromDOM();
  window.__PRODUCT__ = window.__PRODUCT__ || null;

  // -------------------- ADD TO CART --------------------
  (function initAddToCartTracking() {
    function findProductBy(btn) {
      const variantFromBtn = btn?.dataset?.variantId ? String(btn.dataset.variantId) : null;
      const card = btn?.closest?.('.j-productCard') || null;
      if (variantFromBtn && Array.isArray(window.__PRODUCTS_LIST__)) {
        const byVariant = window.__PRODUCTS_LIST__.find(p => String(p.item_variant) === variantFromBtn);
        if (byVariant) return byVariant;
      }
      if (card && Array.isArray(window.__PRODUCTS_LIST__)) {
        const byId = window.__PRODUCTS_LIST__.find(p => String(p.item_id) === String(card.dataset.productId));
        if (byId) return byId;
      }
      if (card) {
        return {
          item_brand: card.dataset.productBrand,
          item_id: card.dataset.productId,
          item_variant: card.dataset.productVariant || variantFromBtn,
          item_name: card.dataset.productName,
          index: Number(card.dataset.index) || 1,
          price: card.dataset.productPrice,
          discount: card.dataset.productDiscount,
          availability: card.dataset.productAvaibility,
          coupon: "",
          item_category: card.dataset.productCollection.trim(),
          item_category2: card.dataset.productCat2
        };
      }
      if (window.__PRODUCT__) return window.__PRODUCT__;
      if (Array.isArray(window.__PRODUCTS_LIST__) && window.__PRODUCTS_LIST__.length) return window.__PRODUCTS_LIST__[0];
      return null;
    }
    function getQuantityFrom(btn) {
      const formButtonsContainer = document.querySelector('.product-form__buttons');
      const qtyPdp = formButtonsContainer?.querySelector?.('input[name="quantity"]');
      if (qtyPdp) return parseInt(qtyPdp.value, 10) || 1;
      const card = btn?.closest?.('.j-productCard');
      const qtyCard = card?.querySelector?.('input[name="quantity"]');
      if (qtyCard) return parseInt(qtyCard.value, 10) || 1;
      return 1;
    }
    function pushAddToCart(product, quantity, method) {
      if (!product) return;
      const dedupeKey = String(product.item_variant || product.item_id || '');
      const now = Date.now();
      window.__LAST_ATC__ = window.__LAST_ATC__ || {};
      if (window.__LAST_ATC__.key === dedupeKey && now - window.__LAST_ATC__.ts < 800) return;
      window.__LAST_ATC__ = {
        key: dedupeKey,
        ts: now
      };
      const priceNum = toNumber(product.price);
      const qty = quantity || 1;
      const value = priceNum * qty;
      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push({
      //   event: 'add_to_cart',
      //   ecommerce: {
      //     currency: 'EUR',
      //     value: product.price * quantity,
      //     items: [{
      //       ...product,
      //       price: priceNum,
      //       quantity: qty,
      //       add_to_cart_method: method
      //     }]
      //   }
      // });

      window.__PRODUCTS__CART__ = window.__PRODUCTS__CART__ || [];
      window.__PRODUCTS__CART__.push({
        ...product,
        price: priceNum,
        quantity: qty
      });
    }

    // Aggiunta da PDP
    const addToCartBtn = document.querySelector('.product-form__submit');
    if (addToCartBtn && (window.__PRODUCT__ || window.__PRODUCTS_LIST__?.length > 0)) {
      addToCartBtn.addEventListener('click', () => {
        const variantIdInput = document.querySelector('form.product-form [name="id"]');
        const selectedVariantId = variantIdInput ? String(variantIdInput.value) : null;
        const source = window.__PRODUCT__ ? [window.__PRODUCT__] : window.__PRODUCTS_LIST__;
        const product = (selectedVariantId ? source.find(p => String(p.item_variant) === selectedVariantId) : null) || source[0];
        const quantity = getQuantityFrom(addToCartBtn);
        pushAddToCart(product, quantity, 'pdp');
      });
    }

    // Aggiunta da PLP o altri contesti
    document.body.addEventListener('click', e => {
      if (e.target.closest('a[is="cart-remove-button"], .j-cartItem')) return;
      const btn = e.target.closest('[data-variant-id]');
      if (!btn) return;
      if (btn.matches('.quickbuy__button') && btn.hasAttribute('aria-controls')) return;
      if (btn.hasAttribute('aria-controls') && /^quickview/i.test(btn.getAttribute('aria-controls') || '')) return;
      const isPdp = document.body.classList.contains('template-product');
      const method = isPdp ? 'pdp' : getContext();
      const product = findProductBy(btn);
      const quantity = getQuantityFrom(btn);
      pushAddToCart(product, quantity, method);
    });
  })();

  // -------------------- REMOVE FROM CART --------------------
  document.body.addEventListener('click', e => {
    if (e.target.matches('a[is="cart-remove-button"]')) {
      const item = e.target.closest('.j-cartItem');
      const id = item?.dataset.id;
      const qtyInput = item?.querySelector('.j-qtyBtn');
      const products = window.__PRODUCTS__CART__.filter(p => String(p.item_id) === id);
      if (products.length > 0) {
        const product = products[0];
        const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        const whereRemove = document.body.classList.contains('template-cart') ? 'Cart' : 'Mini cart';
        // window.dataLayer = window.dataLayer || [];
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'remove_from_cart',
            ecommerce: {
              currency: 'EUR',
              value: product.price * quantity,
              items: [{
                ...product,
                price: toNumber(product.price),
                remove_to_cart_method: whereRemove
              }]
            }
          });
        }
      }
    }
  });

  // --- SELECT ITEM  ---
  document.body.addEventListener('click', e => {
    if (e.target.closest('[data-variant-id], .product-form__submit[data-back-in-stock]')) return;
    const card = e.target.closest('.j-productCard');
    if (card) {
      const id = card.dataset.productId;
      const product = window.__PRODUCTS_LIST__.find(p => String(p.item_id) === id);
      if (product) {
        // window.dataLayer = window.dataLayer || [];
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'select_item',
            ecommerce: {
              currency: 'EUR',
              items: [product]
            }
          });
        }
      }
    }
  });

  // -------------------- VIEW ITEM, LIST & CART --------------------
  (function checkConsentAndPush() {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const hasConsent = window.dataLayer?.some(dl => dl.event === "avacy_consent_update");
      const elapsed = Date.now() - startTime;
      if (hasConsent || elapsed >= 7000) {
        clearInterval(interval);

        // PDP: view_item
        // if (window.__PRODUCT__) {
        //   window.dataLayer.push({
        //     event: 'view_item',
        //     ecommerce: { currency: 'EUR', items: [window.__PRODUCT__] }
        //   });
        // }

        const isPdp = document.body.classList.contains('template-product');
        if (isPdp) {
          let fired = false;
          function onScroll() {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
            const scrolledPercent = (scrollTop + windowHeight) / docHeight * 100;
            if (scrolledPercent >= 70 && !fired) {
              fired = true;
              window.removeEventListener('scroll', onScroll);
              const products = collectProductsFromDOM();
              if (products.length > 0) {
                window.__PRODUCTS_LIST__ = products;
                if (window.dataLayer) {
                  window.dataLayer.push({
                    event: 'view_item_list',
                    ecommerce: {
                      currency: 'EUR',
                      items: products
                    }
                  });
                }
              }
            }
          }
          window.addEventListener('scroll', onScroll);
        } else {
          const products = collectProductsFromDOM();
          if (products.length > 0) {
            window.__PRODUCTS_LIST__ = products;
              if (window.dataLayer) {
                window.dataLayer.push({
                  event: 'view_item_list',
                  ecommerce: {
                    currency: 'EUR',
                    items: products
                }
              });
            }
          }
        }

        // view_cart
        function pushViewCart(where = 'cart_page') {
          const items = (window.__PRODUCTS__CART__ || []).map(p => ({
            ...p,
            price: toNumber(p.price),
            quantity: p.quantity || 1
          }));
          if (items.length === 0) return;
          const value = items.reduce((sum, item) => sum + toNumber(item.price) * (item.quantity || 1), 0);
          // window.dataLayer = window.dataLayer || [];
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'view_cart',
              ecommerce: {
                currency: 'EUR',
                value,
                items
              }
            });
          }
        }
        if (document.body.classList.contains('template-cart')) pushViewCart('cart_page');
        const miniCartEl = document.querySelector('.mini-cart, .drawer[aria-hidden], .cart-drawer');
        if (miniCartEl) {
          const observer = new MutationObserver(mutations => {
            mutations.forEach(m => {
              if (m.attributeName === 'class' || m.attributeName === 'aria-hidden') {
                const isOpen = !miniCartEl.hasAttribute('aria-hidden') || miniCartEl.classList.contains('is-open');
                if (isOpen) pushViewCart('mini_cart');
              }
            });
          });
          observer.observe(miniCartEl, {
            attributes: true
          });
        }
      }
    }, 500);
  })();
});

// --- EVENTO PER APPENDERE PRODOTTI DINAMICAMENTE ---
document.addEventListener('productFetchAppended', e => {
  const product = e.detail.element;
  const index = e.detail.offset;
  const newProducts = Array.from(product.querySelectorAll('.j-productCard')).map((card, i) => ({
    item_brand: card.dataset.productBrand,
    item_id: card.dataset.productId,
    item_variant: card.dataset.productVariant,
    item_name: card.dataset.productName,
    index: index + i,
    price: card.dataset.productPrice,
    discount: card.dataset.productDiscount,
    availability: card.dataset.productAvaibility,
    coupon: "",
    item_category: card.dataset.productCollection.trim(),
    item_category2: card.dataset.productCat2
  }));
  window.__PRODUCTS_LIST__ = window.__PRODUCTS_LIST__ || [];
  window.__PRODUCTS_LIST__.push(...newProducts);
});
/******/ })()
;